'use client';

import { deepMerge } from '../../utils/deep-merge/deep-merge.mjs';
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
function mergeThemeOverrides() {
  for (var _len = arguments.length, overrides = new Array(_len), _key = 0; _key < _len; _key++) {
    overrides[_key] = arguments[_key];
  }
  return overrides.reduce(function (acc, override) {
    return deepMerge(acc, override);
  }, {});
}
export { mergeThemeOverrides };